import React, { Component } from "react";
import OutfitListView from "presentational/common/outfitUnit/OutfitListView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

class SearchOutfitList extends Component {
  static propTypes = {
    getList: PropTypes.func.isRequired,
    outfitList: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired
  };

  render() {
    const { isLoading, isEnd, outfitList, getList } = this.props;

    return (
      <div>
        <OutfitListView
          list={outfitList}
          isLoading={isLoading}
          isEnd={isEnd}
          callNextListFn={getList}
          emptyListText={<TXT name="msg_emptyListSearch" />}
        />
      </div>
    );
  }
}

export default SearchOutfitList;
